var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"information"}},[_c('Header',{on:{"update":_vm.handleUpdate}}),_c('NewsList',{key:_vm.newsList}),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }